import { PERMISSIONS } from "./constants";

export function permissionLeaves(value: unknown): string[] {
  if (typeof value === "string") return [value];
  if (value && typeof value === "object") {
    return Object.values(value as Record<string, unknown>).flatMap(
      permissionLeaves,
    );
  }
  return [];
}

/** All action keys for a resource. Sidebar and page access use these. */
export const RESOURCE_PERMISSIONS = {
  PRODUCTS: permissionLeaves(PERMISSIONS.PRODUCTS),
  CATEGORIES: permissionLeaves(PERMISSIONS.CATEGORIES),
  USERS_ROLES: permissionLeaves(PERMISSIONS.USERS_ROLES),
  PROMOTIONS: permissionLeaves(PERMISSIONS.PROMOTIONS),
  ORDERS: permissionLeaves(PERMISSIONS.ORDERS),
  INVENTORY: permissionLeaves(PERMISSIONS.INVENTORY),
  MEDIA: permissionLeaves(PERMISSIONS.MEDIA),
  BANNERS: permissionLeaves(PERMISSIONS.WEBSITE.BANNERS),
  HOMEPAGE: permissionLeaves(PERMISSIONS.WEBSITE.HOMEPAGE),
  CATEGORY_LANDING: permissionLeaves(PERMISSIONS.WEBSITE.CATEGORY_LANDING),
  PRODUCT_LISTING: permissionLeaves(PERMISSIONS.WEBSITE.PRODUCT_LISTING),
  ABOUT_US: permissionLeaves(PERMISSIONS.WEBSITE.ABOUT_US),
  CONTACT_US: permissionLeaves(PERMISSIONS.WEBSITE.CONTACT_US),
  DASHBOARD: permissionLeaves(PERMISSIONS.DASHBOARD),
  CONTACT_INQUIRIES: permissionLeaves(PERMISSIONS.CONTACT_INQUIRIES),
  WEBSITE_USERS: permissionLeaves(PERMISSIONS.WEBSITE_USERS),
  REPORTS: permissionLeaves(PERMISSIONS.REPORTS),
  REVIEWS: permissionLeaves(PERMISSIONS.REVIEWS),
  CUSTOMER_RISK: permissionLeaves(PERMISSIONS.CUSTOMER_RISK),
  COMMERCE_SETTINGS: permissionLeaves(PERMISSIONS.COMMERCE_SETTINGS),
} as const;

/** Keys that allow listing existing records. Create/edit/delete do not imply this. */
export const VIEW_PERMISSIONS = {
  PRODUCTS: [PERMISSIONS.PRODUCTS.VIEW_ANY, PERMISSIONS.PRODUCTS.VIEW_OWN],
  CATEGORIES: [
    PERMISSIONS.CATEGORIES.VIEW_ANY,
    PERMISSIONS.CATEGORIES.VIEW_OWN,
  ],
  USERS_ROLES: [
    PERMISSIONS.USERS_ROLES.VIEW_ANY,
    PERMISSIONS.USERS_ROLES.VIEW_OWN,
  ],
  PROMOTIONS: [
    PERMISSIONS.PROMOTIONS.VIEW_ANY,
    PERMISSIONS.PROMOTIONS.VIEW_OWN,
  ],
  ORDERS: [PERMISSIONS.ORDERS.VIEW_ANY, PERMISSIONS.ORDERS.VIEW_OWN],
  INVENTORY: [PERMISSIONS.INVENTORY.VIEW_ANY, PERMISSIONS.INVENTORY.VIEW_OWN],
  MEDIA: [PERMISSIONS.MEDIA.VIEW_ANY, PERMISSIONS.MEDIA.VIEW_OWN],
  BANNERS: [
    PERMISSIONS.WEBSITE.BANNERS.VIEW_ANY,
    PERMISSIONS.WEBSITE.BANNERS.VIEW_OWN,
  ],
  DASHBOARD: [
    PERMISSIONS.DASHBOARD.OVERVIEW_VIEW_ANY,
    PERMISSIONS.DASHBOARD.OVERVIEW_VIEW_OWN,
  ],
  CONTACT_INQUIRIES: [
    PERMISSIONS.CONTACT_INQUIRIES.VIEW_ANY,
    PERMISSIONS.CONTACT_INQUIRIES.VIEW_OWN,
  ],
  WEBSITE_USERS: [
    PERMISSIONS.WEBSITE_USERS.VIEW_ANY,
    PERMISSIONS.WEBSITE_USERS.VIEW_OWN,
  ],
  REPORTS: [PERMISSIONS.REPORTS.VIEW_ANY, PERMISSIONS.REPORTS.VIEW_OWN],
} as const;
